export default __webpack_public_path__ + "static/egp4@2x-a77f26986e6d60bd16e221fc1ed943b7.jpg";